export default ({
  LayoutName,
  BackgroundColor,
  BackgroundFontColor,
  BackgroundColorElements,
  BackgroundColorElementsR,
  BackgroundColorElementsG,
  BackgroundColorElementsB,
  BackgroundColorR,
  BackgroundColorG,
  BackgroundColorB,
  BackgroundFontColorR,
  BackgroundFontColorG,
  BackgroundFontColorB,
  AppDefaultFont
}) => {
  return `
    .layout-${LayoutName} {
      font-family:  ${AppDefaultFont};
    }
    .layout-${LayoutName} .page,
    .layout-${LayoutName} .login-screen-content,
    .page.layout-${LayoutName},
    .layout-${LayoutName} .panel,
    .panel.layout-${LayoutName} {
      background-color: ${BackgroundColor};
      color: rgba(${BackgroundFontColorR}, ${BackgroundFontColorG}, ${BackgroundFontColorB}, 0.87);
    }
    .layout-${LayoutName} .content-block-title {
      color: rgba(${BackgroundFontColorR}, ${BackgroundFontColorG}, ${BackgroundFontColorB}, 0.87);
    }
    .layout-${LayoutName} .content-block-inner:before {
      background-color: ${BackgroundColor};
    }
    .layout-${LayoutName} .content-block-inner:after {
      background-color: ${BackgroundColor};
    }
    .layout-${LayoutName} .popover .list ul {
      background: none;
    }
    .layout-${LayoutName} .card {
      background: rgba(${BackgroundColorElementsR}, ${BackgroundColorElementsG}, ${BackgroundColorElementsB}, 0.7);
    }
    .layout-${LayoutName} .card-header:after {
      background-color: ${BackgroundColor};
    }
    .layout-${LayoutName} .card-footer {
      color: ${BackgroundFontColor};
    }
    .layout-${LayoutName} .card-footer:before {
      background-color: ${BackgroundColor};
    }
    .layout-${LayoutName} .list ul:before,
    .list.layout-${LayoutName} ul:before {
      background-color: ${BackgroundColor};
    }
    .layout-${LayoutName} .list ul:after,
    .list.layout-${LayoutName} ul:after {
      background-color: ${BackgroundColor};
    }
    .layout-${LayoutName} .list.inset ul,
    .list.layout-${LayoutName}.inset ul {
      background: rgba(${BackgroundColorElementsR}, ${BackgroundColorElementsG}, ${BackgroundColorElementsB}, 0.7);
    }
    .layout-${LayoutName} .list.notifications > ul,
    .list.layout-${LayoutName}.notifications > ul {
      background: none;
    }
    .layout-${LayoutName} li.sorting {
      background-color: rgba(${BackgroundColorElementsR}, ${BackgroundColorElementsG}, ${BackgroundColorElementsB}, 0.8);
    }
    .layout-${LayoutName} .swipeout-actions-left a,
    .layout-${LayoutName} .swipeout-actions-right a {
      background-color: ${BackgroundColorElements};
    }
    .layout-${LayoutName} .list .item-inner:after,
    .layout-${LayoutName} .list ul ul li:last-child .item-inner:after {
      background-color: ${BackgroundFontColor};
    }
    .layout-${LayoutName} .item-after,
    .layout-${LayoutName} .item-text {
      color: rgba(${BackgroundColorElementsR}, ${BackgroundColorElementsG}, ${BackgroundColorElementsB}, 0.7);
    }
    .layout-${LayoutName} .list-label {
      color: #bbb;
    }
    .layout-${LayoutName} .item-divider,
    .layout-${LayoutName} .list-group-title {
      background: ${BackgroundColorElements};
      color: #bbb;
    }
    .layout-${LayoutName} .item-divider:before,
    .layout-${LayoutName} .list-group-title:before {
      background-color: ${BackgroundColor};
    }
    .layout-${LayoutName} .contacts-block .list-group-title {
      background: none;
    }
    .layout-${LayoutName} .autocomplete-dropdown {
      background: ${BackgroundColorElements};
    }
    .layout-${LayoutName} .autocomplete-dropdown .list {
      color: rgba(${BackgroundFontColorR}, ${BackgroundFontColorG}, ${BackgroundFontColorB}, 0.54);
    }
    .layout-${LayoutName} .autocomplete-dropdown .list b {
      color: rgba(${BackgroundFontColorR}, ${BackgroundFontColorG}, ${BackgroundFontColorB}, 0.87);
    }
    html:not(.watch-active-state) .layout-${LayoutName} .item-link:active,
    html:not(.watch-active-state) .layout-${LayoutName} label.label-checkbox:active,
    html:not(.watch-active-state) .layout-${LayoutName} label.label-radio:active,
    .layout-${LayoutName} .item-link.active-state,
    .layout-${LayoutName} label.label-checkbox.active-state,
    .layout-${LayoutName} label.label-radio.active-state {
      background-color: rgba(${BackgroundColorElementsR}, ${BackgroundColorElementsG}, ${BackgroundColorElementsB}, 0.05);
    }
    .layout-${LayoutName} .list input[type="text"],
    .layout-${LayoutName} .list input[type="password"],
    .layout-${LayoutName} .list input[type="search"],
    .layout-${LayoutName} .list input[type="email"],
    .layout-${LayoutName} .list input[type="tel"],
    .layout-${LayoutName} .list input[type="url"],
    .layout-${LayoutName} .list input[type="date"],
    .layout-${LayoutName} .list input[type="datetime-local"],
    .layout-${LayoutName} .list input[type="time"],
    .layout-${LayoutName} .list input[type="number"],
    .layout-${LayoutName} .list select,
    .layout-${LayoutName} .list textarea {
      color: ${BackgroundFontColor};
    }
    .layout-${LayoutName} .list input[type="text"]::-webkit-input-placeholder,
    .layout-${LayoutName} .list input[type="password"]::-webkit-input-placeholder,
    .layout-${LayoutName} .list input[type="search"]::-webkit-input-placeholder,
    .layout-${LayoutName} .list input[type="email"]::-webkit-input-placeholder,
    .layout-${LayoutName} .list input[type="tel"]::-webkit-input-placeholder,
    .layout-${LayoutName} .list input[type="url"]::-webkit-input-placeholder,
    .layout-${LayoutName} .list input[type="date"]::-webkit-input-placeholder,
    .layout-${LayoutName} .list input[type="datetime-local"]::-webkit-input-placeholder,
    .layout-${LayoutName} .list input[type="time"]::-webkit-input-placeholder,
    .layout-${LayoutName} .list input[type="number"]::-webkit-input-placeholder,
    .layout-${LayoutName} .list select::-webkit-input-placeholder,
    .layout-${LayoutName} .list textarea::-webkit-input-placeholder {
      color: rgba(${BackgroundFontColorR}, ${BackgroundFontColorG}, ${BackgroundFontColorB}, 0.35);
    }
    .layout-${LayoutName} .toggle .toggle-icon {
      background: rgba(${BackgroundColorElementsR}, ${BackgroundColorElementsG}, ${BackgroundColorElementsB}, 0.3);
    }
    .layout-${LayoutName} .item-inner:not(.focus-state) .label,
    .layout-${LayoutName} .item-inner:not(.focus-state) .floating-label {
      color: rgba(${BackgroundFontColorR}, ${BackgroundFontColorG}, ${BackgroundFontColorB}, 0.7);
    }
    .layout-${LayoutName} .item-inner:not(.focus-state):not(.not-empty-state) .item-input-field:after,
    .layout-${LayoutName} .item-inner:not(.focus-state):not(.not-empty-state) .input-field:after {
      background-color: rgba(${BackgroundColorElementsR}, ${BackgroundColorElementsG}, ${BackgroundColorElementsB}, 0.12);
    }
    .layout-${LayoutName} label.label-checkbox i.icon-form-checkbox {
      border-color: rgba(${BackgroundColorElementsR}, ${BackgroundColorElementsG}, ${BackgroundColorElementsB}, 0.7);
    }
    .layout-${LayoutName} label.label-radio i.icon-form-radio {
      border-color: rgba(${BackgroundColorElementsR}, ${BackgroundColorElementsG}, ${BackgroundColorElementsB}, 0.7);
    }
    .layout-${LayoutName} .item-link.list-button:after,
    .layout-${LayoutName} .list-button:after {
      background-color: ${BackgroundColorElements};
    }
    .layout-${LayoutName} .page-content .ripple-wave {
      background: rgba(${BackgroundColorElementsR}, ${BackgroundColorElementsG}, ${BackgroundColorElementsB}, 0.3);
    }
    html:not(.watch-active-state) .layout-${LayoutName} .button:not(.button-fill):active,
    .layout-${LayoutName} .button:not(.button-fill).active-state {
      background: rgba(${BackgroundColorR}, ${BackgroundColorG}, ${BackgroundColorB}, 0.1);
    }
    .layout-${LayoutName} .chip {
      background: rgba(${BackgroundColorR}, ${BackgroundColorG}, ${BackgroundColorB}, 0.87);
    }
    .layout-${LayoutName} .timeline-item-inner {
      background: ${BackgroundColorElements};
    }
    .layout-${LayoutName} .timeline-item-divider {
      background: rgba(${BackgroundColorR}, ${BackgroundColorG}, ${BackgroundColorB}, 0.3);
    }
    .layout-${LayoutName} .content-block-inner .timeline-item-inner {
      border-color: ${BackgroundColorElements};
    }
    .layout-${LayoutName} .timeline-item-time {
      color: rgba(${BackgroundFontColorR}, ${BackgroundFontColorG}, ${BackgroundFontColorB}, 0.7);
    }
    .layout-${LayoutName} .data-table tbody tr.data-table-row-selected {
      background: rgba(${BackgroundColorR}, ${BackgroundColorG}, ${BackgroundColorB}, 0.05);
    }
    .layout-${LayoutName} .data-table tbody td:before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: auto;
      right: auto;
      height: 1px;
      width: 100%;
      background-color: ${BackgroundColor};
      display: block;
      z-index: 15;
      -webkit-transform-origin: 50% 0%;
      transform-origin: 50% 0%;
    }
    html.pixel-ratio-2 .layout-${LayoutName} .data-table tbody td:before {
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }
    html.pixel-ratio-3 .layout-${LayoutName} .data-table tbody td:before {
      -webkit-transform: scaleY(0.33);
      transform: scaleY(0.33);
    }
    html:not(.ios):not(.android) .layout-${LayoutName} .data-table tbody tr:hover {
      background: rgba(${BackgroundColorR}, ${BackgroundColorG}, ${BackgroundColorB}, 0.05);
    }
    .layout-${LayoutName} .data-table thead th:not(.sortable-active),
    .layout-${LayoutName} .data-table thead td:not(.sortable-active) {
      color: rgba(${BackgroundFontColorR}, ${BackgroundFontColorG}, ${BackgroundFontColorB}, 0.5);
    }
    .layout-${LayoutName} .data-table th.actions-cell a.link,
    .layout-${LayoutName} .data-table td.actions-cell a.link {
      color: rgba(${BackgroundFontColorR}, ${BackgroundFontColorG}, ${BackgroundFontColorB}, 0.5);
    }
    .layout-${LayoutName} .data-table .sortable-cell:not(.numeric-cell):after,
    .layout-${LayoutName} .data-table .sortable-cell.numeric-cell:before {
      background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20fill%3D'%23ffffff'%20height%3D'24'%20viewBox%3D'0%200%2024%2024'%20width%3D'24'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%3E%3Cpath%20d%3D'M0%200h24v24H0V0z'%20fill%3D'none'%2F%3E%3Cpath%20d%3D'M20%2012l-1.41-1.41L13%2016.17V4h-2v12.17l-5.58-5.59L4%2012l8%208%208-8z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E");
    }
    .layout-${LayoutName} .data-table .data-table-actions a.link {
      color: rgba(${BackgroundFontColorR}, ${BackgroundFontColorG}, ${BackgroundFontColorB}, 0.5);
    }
    .layout-${LayoutName} .page-content{
      background-color: rgba(${BackgroundColorR}, ${BackgroundColorG}, ${BackgroundColorB},.82)!important;
    }
    @media (max-width: 480px) and (orientation: portrait) {
      .layout-${LayoutName} .data-table.data-table-collapsible tr:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: auto;
        right: auto;
        height: 1px;
        width: 100%;
        background-color: ${BackgroundColor};
        display: block;
        z-index: 15;
        -webkit-transform-origin: 50% 0%;
        transform-origin: 50% 0%;
      }
      html.pixel-ratio-2 .layout-${LayoutName} .data-table.data-table-collapsible tr:before {
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
      }
      html.pixel-ratio-3 .layout-${LayoutName} .data-table.data-table-collapsible tr:before {
        -webkit-transform: scaleY(0.33);
        transform: scaleY(0.33);
      }
      .layout-${LayoutName} .data-table.data-table-collapsible tr:hover {
        background-color: inherit;
      }
      .layout-${LayoutName} .data-table.data-table-collapsible td:not(.checkbox-cell):before {
        color: rgba(${BackgroundFontColorR}, ${BackgroundFontColorG}, ${BackgroundFontColorB}, 0.5);
      }
    }
    .layout-${LayoutName} .page-content{
      background-color: rgba(${BackgroundColorR}, ${BackgroundColorG}, ${BackgroundColorB},.82)!important;
    }
    .layout-${LayoutName}  .list ul, .list.layout-${LayoutName} ul, .ratingdiv {
        background: rgba(${BackgroundColorElementsR}, ${BackgroundColorElementsG}, ${BackgroundColorElementsB}, 0.7);
    }
    .layout-${LayoutName} .content-block-inner {
        background: rgba(${BackgroundColorElementsR}, ${BackgroundColorElementsG}, ${BackgroundColorElementsB}, 0.7);
        color: ${BackgroundFontColor};
    }
    .layout-${LayoutName} .track-banner-headphone, .layout-${LayoutName} .headphone-pulse {
      background-color: ${BackgroundColorElements};
    }
    .card__headerNoImageCaption .card__CaptionText {
      color: ${BackgroundFontColor};
    }
    .card__headerImageCaption .card__CaptionText {
      color: #ffffff;
    }
    .detailTitleWrapper {
      background-color: ${BackgroundColorElements};
    }
    .photo-browser-exposed .photo-browser-caption {
      background: black !important;
    }
    .photo-browser-captions-light .photo-browser-caption {
      /*background: rgba(${BackgroundColorR}, ${BackgroundColorG}, ${BackgroundColorB}, .8); */
      color: ${BackgroundFontColor};
      background: transparent !important;
    }
    .photo-browser-exposed .photo-browser-caption .twitter-photo-caption, .photo-browser-exposed .photo-browser-caption .fb-photo-caption {
      opacity: 0;
      background: black !important;
    }
    .layout-onAirDefault .page,
    .layout-onAirDefault .login-screen-content,
    .page.layout-onAirDefault,
    .layout-onAirDefault .panel,
    .panel.layout-onAirDefault {
      background: rgba(${BackgroundColorR}, ${BackgroundColorG}, ${BackgroundColorB}, 1) !important;
      color: ${BackgroundFontColor};
    }
    .photo-browser-swiper-container {
      background: inherit;
    }
    .layout-${LayoutName} .card-header, .layout-${LayoutName} .data-table thead tr {
      border-bottom: 1px solid ${BackgroundFontColor};
    }
    .layout-${LayoutName} .modal-button {
      background: ${BackgroundColor};
    }
    .layout-${LayoutName} .modal-inner {
      background: ${BackgroundColor};
    }
    .layout-${LayoutName} .modal-overlay {
      background: rgba(${BackgroundColorElementsR}, ${BackgroundColorElementsG}, ${BackgroundColorElementsB}, 0.5);
    }
    .layout-${LayoutName} .modal, .layout-${LayoutName} .modal-title {
      color: ${BackgroundFontColor};
      background: ${BackgroundColor};
    }
    .md .layout-${LayoutName} .image-box .link {
      display: block;
    }
    .photo-browser-exposed .fab {
      opacity: 0;
      visibility: hidden;
      pointer-events: none;
    }
    .md .page-opacity-effect {
      display: none;
    }
    .layout-${LayoutName} .sheet-modal-inner {
      background-color: ${BackgroundColor};
      color: ${BackgroundFontColor};
    }
    .md .block-title {
      text-transform: uppercase;
      color: ${BackgroundFontColor};
    }
    .md .list .item-after {
      color: ${BackgroundFontColor};
    }
    .layout-${LayoutName} .rss-feed-content {
      color: ${BackgroundFontColor};
    }
    .md .messages-title {
      color: ${BackgroundFontColor};
    }
    .md .message-received .message-bubble {
      color: ${BackgroundFontColor};
      background-color: rgba(${BackgroundColorElementsR}, ${BackgroundColorElementsG}, ${BackgroundColorElementsB}, 0.7);
    }
    .md .message-received.message-tail .message-bubble:before {     
      border-bottom: 8px solid rgba(${BackgroundColorElementsR}, ${BackgroundColorElementsG}, ${BackgroundColorElementsB}, 0.7);
    }
    .md .message-received .message-text-header, .md .message-received .message-text-footer {
      color: ${BackgroundFontColor};
      opacity: 0.7;
    }
    .lable-default-font-color {
      color: ${BackgroundFontColor}!important;
    }
    .setProductPopoverScroll{
      background: rgba(${BackgroundColorElementsR}, ${BackgroundColorElementsG}, ${BackgroundColorElementsB}, 0.8)!important;
    }
    .infinite-status-prompt {
      color:${BackgroundFontColor}!important;
    }
    .custom-file-upload, .close-icon {
      background-color: rgba(${BackgroundColorElementsR}, ${BackgroundColorElementsG}, ${BackgroundColorElementsB}, 0.7) !important;
    }
  `
}
/*
.md .toolbar:not(.toolbar-bottom-md):not(.messagebar) {
  top: 56px;
}
*/



// WEBPACK FOOTER //
// ./src/template/material/layout.js